import { useEffect, useState, useCallback } from 'react';
import { api } from '../../App';
import { toast } from 'sonner';

export const useLiveMarket = () => {
  const [status, setStatus] = useState(null);
  const [portfolio, setPortfolio] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [s, p] = await Promise.all([api.get('/sb-live/status'), api.get('/sb-live/portfolio')]);
      setStatus(s.data);
      setPortfolio(p.data);
    } catch {
      setStatus((prev) => prev || { error: true });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const startPurchase = async (businessId, amount) => {
    const res = await api.post('/sb-live/purchase', {
      business_id: businessId, amount, origin_url: window.location.origin,
    });
    window.location.href = res.data.checkout_url;
  };

  const acceptRisk = async () => {
    await api.post('/sb-live/risk-ack');
    await refresh();
  };

  const linkBank = async () => {
    try {
      const res = await api.post('/sb-live/bank/connect', { origin_url: window.location.origin });
      window.location.href = res.data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Bank linking failed');
    }
  };

  return { status, portfolio, refresh, startPurchase, acceptRisk, linkBank };
};

export const pollPurchase = async (sessionId, attempts = 10) => {
  for (let i = 0; i < attempts; i += 1) {
    const res = await api.get(`/sb-live/purchase/${sessionId}`);
    if (res.data.status !== 'pending' && res.data.status !== 'processing') return res.data;
    await new Promise((r) => setTimeout(r, 2000));
  }
  return { status: 'pending' };
};
